import Fade from "react-reveal/Fade";
import React from "react";
import {graphql, StaticQuery} from "gatsby"

const SolutionsList =  ({ data }) => {
    const items = data.allPrismicSolutions.edges;
    return (
        <div className="c-cards">
            {items.map((data, index) => <SolutionItem key={index} index={index} item={data.node} />)}
        </div>
    )
}

const SolutionItem = ({ item, index }) => {
    return (
        <Fade delay={200 * index}>
            <div className={`o-card o-card--${index})`}>
                <div className="o-card__content">
                    <h2 className={`o-card__title`}>{item.data.title.text}</h2>
                    <div className={`o-card__body`} dangerouslySetInnerHTML={{__html: item.data.card_description.html}}/>
                </div>
            </div>
        </Fade>
    )
}

export default props => (
    <StaticQuery
        query={graphql`
          query {
          allPrismicSolutions {
            edges {
              node {
                uid
                data {
                  title {
                    text
                  }
                  card_description {
                    html
                  }
                }
              }
            }
          }
      }
    `}
        render={data => <SolutionsList data={data} {...props} />}
    />
)
